/* ============================================
   OAKLEY HOMEPAGE — script.js
   ============================================ */
(function () {
  'use strict';

  /* ==========================================
     MEGA DROPDOWN — position panels under header
     ========================================== */
  var header2     = document.getElementById('header');
  var navGroups   = document.querySelectorAll('.nav-group');
  var backdrop    = document.getElementById('megaBackdrop');
  var activeGroup = null;
  var closeTimer  = null;

  function positionDrops() {
    if (!header2) return;
    /* Use header-row2 so dropdown appears below nav row, not above it */
    var row2 = header2.querySelector('.header-row2');
    var el   = row2 || header2;
    var bottom = el.getBoundingClientRect().bottom;
    var drops = document.querySelectorAll('.mega-drop');
    drops.forEach(function (d) { d.style.top = bottom + 'px'; });
    if (backdrop) backdrop.style.top = bottom + 'px';
  }
  positionDrops();
  window.addEventListener('scroll', positionDrops, { passive: true });
  window.addEventListener('resize', positionDrops);

  function openGroup(group) {
    if (activeGroup && activeGroup !== group) closeGroup(activeGroup, true);
    clearTimeout(closeTimer);
    group.classList.add('drop-open');
    if (backdrop) backdrop.classList.add('visible');
    activeGroup = group;
  }

  function closeGroup(group, instant) {
    if (instant) {
      group.classList.remove('drop-open');
      if (backdrop) backdrop.classList.remove('visible');
      if (activeGroup === group) activeGroup = null;
    } else {
      closeTimer = setTimeout(function () {
        group.classList.remove('drop-open');
        if (backdrop) backdrop.classList.remove('visible');
        if (activeGroup === group) activeGroup = null;
      }, 80); // tiny delay prevents flicker when moving mouse between items
    }
  }

  navGroups.forEach(function (group) {
    group.addEventListener('mouseenter', function () { openGroup(group); });
    group.addEventListener('mouseleave', function () { closeGroup(group, false); });

    // Keep panel open when mouse re-enters from the panel itself
    var drop = group.querySelector('.mega-drop');
    if (drop) {
      drop.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        group.classList.add('drop-open');
        if (backdrop) backdrop.classList.add('visible');
        activeGroup = group;
      });
      drop.addEventListener('mouseleave', function () { closeGroup(group, false); });
    }
  });

  // Close on backdrop click
  if (backdrop) {
    backdrop.addEventListener('click', function () {
      if (activeGroup) closeGroup(activeGroup, true);
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeGroup) closeGroup(activeGroup, true);
  });

  /* ==========================================
     MOBILE NAV TOGGLE
     ========================================== */
  var navToggle  = document.getElementById('navToggle');
  var navPrimary = document.getElementById('navPrimary');
  var navOpen    = false;

  if (navToggle && navPrimary) {
    navToggle.addEventListener('click', function () {
      navOpen = !navOpen;
      navPrimary.classList.toggle('open', navOpen);
      // Position the menu just below the header
      if (navOpen && header2) {
        var hBottom = header2.getBoundingClientRect().bottom;
        navPrimary.style.top = hBottom + 'px';
      }
      var spans = navToggle.querySelectorAll('span');
      if (navOpen) {
        spans[0].style.transform = 'translateY(6.5px) rotate(45deg)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'translateY(-6.5px) rotate(-45deg)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });
    document.addEventListener('click', function (e) {
      if (navOpen && !navPrimary.contains(e.target) && !navToggle.contains(e.target)) {
        navOpen = false;
        navPrimary.classList.remove('open');
        var spans = navToggle.querySelectorAll('span');
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });
  }

  /* ==========================================
     MOBILE DRAWER NAV
     ========================================== */
  var mobDrawer  = document.getElementById('mobDrawer');
  var mobOverlay = document.getElementById('mobOverlay');
  var mobInner   = mobDrawer ? mobDrawer.querySelector('.mob-drawer-inner') : null;
  var navToggle  = document.getElementById('navToggle');

  function openDrawer() {
    if (!mobDrawer) return;
    mobDrawer.classList.add('open');
    mobOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!mobDrawer) return;
    mobDrawer.classList.remove('open');
    mobOverlay.classList.remove('open');
    document.body.style.overflow = '';
    // Reset to level 1
    setTimeout(function() {
      if (mobInner) mobInner.classList.remove('slide');
    }, 350);
  }

  // Hamburger opens drawer
  if (navToggle) {
    navToggle.addEventListener('click', function() {
      if (mobDrawer && mobDrawer.classList.contains('open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  // Overlay closes drawer
  if (mobOverlay) mobOverlay.addEventListener('click', closeDrawer);

  // Close buttons
  document.querySelectorAll('.mob-close').forEach(function(btn) {
    btn.addEventListener('click', closeDrawer);
  });

  // Forward: tap item with sub-level
  document.querySelectorAll('.mob-nav-has-sub').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (mobInner) mobInner.classList.add('slide');
    });
  });

  // Back button
  document.querySelectorAll('.mob-back').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (mobInner) mobInner.classList.remove('slide');
    });
  });


  var track      = document.getElementById('carouselTrack');
  var slides     = track ? track.querySelectorAll('.c-slide') : [];
  var totalSlides = slides.length;
  var current    = 1;
  var cdots      = document.querySelectorAll('.cdot');

  function updateCarousel() {
    slides.forEach(function (s) {
      s.classList.remove('c-slide-main');
      s.style.opacity = '0.4';
      s.style.transform = 'scale(0.85)';
    });
    if (slides[current]) {
      slides[current].classList.add('c-slide-main');
      slides[current].style.opacity = '1';
      slides[current].style.transform = 'scale(1)';
    }
    var dotIdx = current % cdots.length;
    cdots.forEach(function (d, i) { d.classList.toggle('active', i === dotIdx); });
  }

  var arrowPrev = document.getElementById('arrowPrev');
  var arrowNext = document.getElementById('arrowNext');
  if (arrowPrev && arrowNext && totalSlides > 0) {
    arrowPrev.addEventListener('click', function () {
      current = (current - 1 + totalSlides) % totalSlides;
      updateCarousel();
    });
    arrowNext.addEventListener('click', function () {
      current = (current + 1) % totalSlides;
      updateCarousel();
    });
  }

  /* ==========================================
     SPORT GRID HOVER PREVIEW
     ========================================== */
  var sportRows  = document.querySelectorAll('.sport-row');
  var previewImg = document.getElementById('sportPreviewImg');

  sportRows.forEach(function (row) {
    row.addEventListener('mouseenter', function () {
      var img = row.getAttribute('data-img');
      if (img && previewImg) {
        previewImg.style.opacity = '0';
        setTimeout(function () {
          previewImg.src = img;
          previewImg.style.opacity = '1';
        }, 160);
      }
      sportRows.forEach(function (r) { r.classList.remove('sport-row-active'); });
      row.classList.add('sport-row-active');
    });
  });

  /* ==========================================
     PRODUCT SCROLLER — drag + progress bar
     ========================================== */
  function initScroller(wrapId, fillId) {
    var wrap = document.getElementById(wrapId);
    var fill = document.getElementById(fillId);
    if (!wrap) return;

    function updateProgress() {
      var max = wrap.scrollWidth - wrap.clientWidth;
      var pct = max > 0 ? (wrap.scrollLeft / max) * 100 : 0;
      if (fill) fill.style.width = pct + '%';
    }
    wrap.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    var isDragging = false, dragStartX = 0, scrollStart = 0;
    wrap.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragStartX = e.pageX;
      scrollStart = wrap.scrollLeft;
      wrap.classList.add('grabbing');
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      wrap.scrollLeft = scrollStart - (e.pageX - dragStartX);
    });
    window.addEventListener('mouseup', function () {
      isDragging = false;
      wrap.classList.remove('grabbing');
    });
    wrap.addEventListener('click', function (e) {
      if (Math.abs(wrap.scrollLeft - scrollStart) > 4) e.preventDefault();
    });
  }

  initScroller('psWrap',  'psProgressFill');
  initScroller('psWrap2', 'psProgressFill2');

  /* ==========================================
     FILTER TABS — hide/show cards, reflow into grid when filtered
     ========================================== */
  document.querySelectorAll('.ps-section').forEach(function (section) {
    var tabs = section.querySelectorAll('.ps-tab');
    if (!tabs.length) return;

    var cards     = section.querySelectorAll('.ps-card');
    var trackWrap = section.querySelector('.ps-track-wrap');
    var track     = section.querySelector('.ps-track');
    var progFill  = section.querySelector('.ps-progress-fill');
    var dragLabel = section.querySelector('.ps-drag-label');
    var progBar   = section.querySelector('.ps-progress-bar');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {

        // 1. Update active tab
        tabs.forEach(function (t) { t.classList.remove('ps-tab-active'); });
        tab.classList.add('ps-tab-active');

        var filter = tab.getAttribute('data-filter');

        if (filter === 'all') {
          // SCROLL MODE — show all, restore horizontal scroll layout
          cards.forEach(function (card) {
            card.style.display = '';
            card.classList.remove('ps-dimmed');
          });
          trackWrap.classList.remove('ps-grid-mode');
          track.classList.remove('ps-track-grid');
          if (progBar) progBar.style.display = '';
          if (dragLabel) dragLabel.style.display = '';
          trackWrap.scrollLeft = 0;
          if (progFill) progFill.style.width = '0%';

        } else {
          // GRID MODE — hide non-matching, reflow matching side by side
          cards.forEach(function (card) {
            if (card.getAttribute('data-category') === filter) {
              card.style.display = '';
              card.classList.remove('ps-dimmed');
            } else {
              card.style.display = 'none';
              card.classList.remove('ps-dimmed');
            }
          });
          trackWrap.classList.add('ps-grid-mode');
          track.classList.add('ps-track-grid');
          if (progBar) progBar.style.display = 'none';
          if (dragLabel) dragLabel.style.display = 'none';
          trackWrap.scrollLeft = 0;
        }
      });
    });
  });





  var srEls = document.querySelectorAll('.sr');

  if ('IntersectionObserver' in window) {
    var srObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          srObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    srEls.forEach(function (el) { srObserver.observe(el); });
  } else {
    // fallback: show everything immediately
    srEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  /* ==========================================
     FAQ SIDEBAR — smooth scroll with header offset
     ========================================== */
  var faqNavLinks = document.querySelectorAll('.faq-nav-link');

  faqNavLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = link.getAttribute('href');
      if (!targetId || targetId.charAt(0) !== '#') return;
      var target = document.querySelector(targetId);
      if (!target) return;
      e.preventDefault();

      // Calculate header height for offset
      var headerEl = document.getElementById('header');
      var offset = headerEl ? headerEl.getBoundingClientRect().height + 24 : 120;
      var targetTop = target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({ top: targetTop, behavior: 'smooth' });

      // Update active link
      faqNavLinks.forEach(function (l) { l.classList.remove('faq-nav-active'); });
      link.classList.add('faq-nav-active');
    });
  });

  /* ==========================================
     FAQ SIDEBAR — highlight active section on scroll
     ========================================== */
  var faqLinks = document.querySelectorAll('.faq-nav-link');
  var faqCategories = document.querySelectorAll('.faq-category');

  if (faqLinks.length && faqCategories.length) {
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY + 160;
      faqCategories.forEach(function (cat) {
        if (cat.offsetTop <= scrollY) {
          faqLinks.forEach(function (l) { l.classList.remove('faq-nav-active'); });
          var active = document.querySelector('.faq-nav-link[href="#' + cat.id + '"]');
          if (active) active.classList.add('faq-nav-active');
        }
      });
    }, { passive: true });
  }


  var header = document.getElementById('header');
  window.addEventListener('scroll', function () {
    header.style.boxShadow = window.scrollY > 10 ? '0 2px 12px rgba(0,0,0,0.1)' : '';
  }, { passive: true });

})();

/* =======================================
   PRODUCT DETAIL PAGE
   ======================================= */
// Subscribe toggle
    const subOpts = document.querySelectorAll('.sub-opt');
    const priceDisplay = document.getElementById('priceDisplay');
    const priceStrike = document.getElementById('priceStrike');
    const PRICE_ONE = 39.95;
    const PRICE_SUB = 29.96;
    subOpts.forEach(opt => {
      opt.addEventListener('click', () => {
        subOpts.forEach(o => o.classList.remove('active'));
        opt.classList.add('active');
        var saleOn = window.TVP_SALE && TVP_SALE.on(TVP_SALE.currentHandle());
        if (opt.dataset.type === 'sub') {
          priceDisplay.textContent = '$' + (saleOn && TVP_SALE.subToo ? TVP_SALE.price(PRICE_SUB) : PRICE_SUB.toFixed(2));
          priceStrike.textContent = '$' + PRICE_ONE.toFixed(2);
          priceStrike.style.display = 'inline';
        } else if (saleOn) {
          priceDisplay.textContent = '$' + TVP_SALE.price(PRICE_ONE);
          priceStrike.textContent = '$' + PRICE_ONE.toFixed(2);
          priceStrike.style.display = 'inline';
        } else {
          priceDisplay.textContent = '$' + PRICE_ONE.toFixed(2);
          priceStrike.style.display = 'none';
        }
      });
    });

    // Quantity
    const qtyVal = document.getElementById('qtyVal');
    let qty = 1;
    if (document.getElementById('qtyMinus')) { document.getElementById('qtyMinus').addEventListener('click', () => { if (qty > 1) { qty--; qtyVal.textContent = qty; } }); }
    if (document.getElementById('qtyPlus')) { document.getElementById('qtyPlus').addEventListener('click', () => { if (qty < 10) { qty++; qtyVal.textContent = qty; } }); }

    // Ingredient accordion
    document.querySelectorAll('.ing').forEach(ing => {
      ing.querySelector('.ing-head').addEventListener('click', () => ing.classList.toggle('open'));
    });

    // Two-column FAQ
    document.querySelectorAll('.faq2-q').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.faq2-q').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.faq2-answer').forEach(a => a.classList.remove('active'));
        btn.classList.add('active');
        document.getElementById(btn.dataset.target).classList.add('active');
      });
    });

    // Two-column FAQ

    // Thumbnails
    document.querySelectorAll('.prod-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('.prod-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const img = thumb.dataset.img;
        if (img) document.getElementById('mainImg').src = img;
      });
    });

// Search bar expand on focus
document.addEventListener('DOMContentLoaded', function() {
  var bar = document.querySelector('.search-bar');
  var input = document.querySelector('.search-input');
  if (!bar || !input) return;
  input.addEventListener('focus', function() { bar.classList.add('expanded'); });
  input.addEventListener('blur', function() { if (!input.value) bar.classList.remove('expanded'); });
});


// Transparent sticky header on scroll
document.addEventListener('DOMContentLoaded', function() {
  var header = document.getElementById('header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    if (window.scrollY > 60) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
});


// Transparent sticky header on scroll
document.addEventListener('DOMContentLoaded', function() {
  var header = document.getElementById('header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    if (window.scrollY > 60) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
});
